export const CHECKPOINT_LABELS: Record<string, string> = {
  AUTH_SIGNUP: 'Sign up',
  AUTH_LOGIN: 'Sign in',
  APPLICATION_CREATE: 'Create application',
  PHONE_OTP_VERIFY: 'Phone OTP verify',
  CONSENT_CAPTURE: 'Consent capture',
  IDENTITY_VERIFY: 'Identity verify (upload)',
  IDENTITY_INIT: 'Identity SDK init',
  BANK_CONNECT: 'Bank connect',
};

export const SIGNAL_GLOSSARY: Array<{ key: string; label: string; description: string }> = [
  { key: 'vpn', label: 'VPN', description: 'Traffic routed through a VPN or anonymizing service.' },
  { key: 'proxy', label: 'Proxy', description: 'Residential or public proxy detected on the request IP.' },
  { key: 'incognito', label: 'Incognito', description: 'Private / incognito browsing mode.' },
  { key: 'virtual_machine', label: 'Virtual machine', description: 'Browser running inside a VM.' },
  { key: 'tampering', label: 'Tampering', description: 'Anomalous browser signature or anti-detect tooling.' },
  { key: 'bot', label: 'Bot', description: 'Automated browser or headless tooling.' },
  { key: 'high_activity_device', label: 'High activity', description: 'Unusually high event volume from this device.' },
  { key: 'developer_tools', label: 'Developer tools', description: 'Browser DevTools were open during identification.' },
  { key: 'suspect_score', label: 'Suspect score', description: 'Fingerprint composite risk score (higher = riskier).' },
  { key: 'privacy_settings', label: 'Privacy browser', description: 'Tor or fingerprint-blocking privacy browser.' },
];

export const CHECKPOINT_GLOSSARY = Object.entries(CHECKPOINT_LABELS).map(([key, label]) => ({
  key,
  label,
}));

export const POLICY_REASON_LABELS: Record<string, string> = {
  VPN: 'VPN detected',
  PROXY: 'Proxy detected',
  INCOGNITO: 'Incognito browser',
  VM: 'Virtual machine',
  TAMPERING: 'Browser tampering',
  BOT_BAD: 'Bad bot',
  SUSPECT_SCORE: 'High suspect score',
  HIGH_ACTIVITY: 'High activity device',
  DEVELOPER_TOOLS: 'Developer tools open',
  DUPLICATE_SIGNUP_VISITOR: 'Duplicate device at signup',
  EVENT_ID_REPLAY: 'Replayed event ID',
  EVENT_TOO_OLD: 'Stale event ID',
  FP_REPLAYED_PAYLOAD: 'Replayed Fingerprint payload',
  FP_AGENT_UNAVAILABLE: 'Fingerprint API unavailable',
  FP_ENFORCEMENT_DISABLED: 'Enforcement off (observe only)',
  FP_NO_EVENT_ID: 'No event ID sent',
  CLEAN: 'Clean',
};

export function checkpointLabel(checkpoint: string): string {
  return CHECKPOINT_LABELS[checkpoint] ?? checkpoint.replace(/_/g, ' ');
}

export function policyReasonLabel(code: string): string {
  return POLICY_REASON_LABELS[code] ?? code.replace(/_/g, ' ').toLowerCase();
}

export function signalLabel(signal: string): string {
  const found = SIGNAL_GLOSSARY.find((s) => s.key === signal);
  return found?.label ?? signal.replace(/_/g, ' ');
}

export function verdictSeverity(
  level: string,
): 'success' | 'info' | 'warning' | 'error' {
  switch (level) {
    case 'blocked':
      return 'error';
    case 'review':
      return 'warning';
    case 'observe':
      return 'info';
    default:
      return 'success';
  }
}

export function decisionChipColor(
  decision: string,
): 'default' | 'success' | 'warning' | 'error' {
  if (decision === 'BLOCK') return 'error';
  if (decision === 'REVIEW') return 'warning';
  if (decision === 'ALLOW') return 'success';
  return 'default';
}
